export default __webpack_public_path__ + "static/media/DNo.30-5.747ed2dc.jpg";